import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  Injectable,
  Input,
  OnInit,
} from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import {
  NgbActiveModal,
  NgbDate,
  NgbDateAdapter,
  NgbDateParserFormatter,
  NgbDatepickerModule,
  NgbDateStruct,
  NgbModal,
  NgbModule,
} from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { CustomLandingModule } from '../../custom-landing.module';
import { ConsignmentsConfirmBidPopupComponent } from '../consignments-confirm-bid-popup/consignments-confirm-bid-popup.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ToastrService } from 'ngx-toastr';
import { CustomProfileService } from 'src/app/core/services/custom-profile.service';
import { MasterData } from 'src/app/core/model/master-data.model';
import { Console } from 'console';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommondirectiveDirective } from 'src/app/shared/directive/commondirective.directive';
import { WholeNumberdirectiveDirective } from 'src/app/shared/directive/commondirective.directive';

@Injectable()
// export class CustomAdapter extends NgbDateAdapter<string> {
//   readonly DELIMITER = '/';

//   fromModel(value: string | null): NgbDateStruct | null {
//     if (value) {
//       const date = value.split(this.DELIMITER);
//       return {
//         day: parseInt(date[0], 10),
//         month: parseInt(date[1], 10),
//         year: parseInt(date[2], 10),
//       };
//     }
//     return null;
//   }

//   toModel(date: NgbDateStruct | null): string | null {
//     return date ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year : null;
//   }
// }

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  readonly DELIMITER = '/';

  parse(value: string): NgbDateStruct | null {
    if (value) {
      const date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date
      ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year
      : '';
  }
}
@Component({
  selector: 'app-consignments-popupmodal',
  standalone: true,
  imports: [
    NgMultiSelectDropDownModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgSelectModule,
    NgbDatepickerModule,
    CommondirectiveDirective,WholeNumberdirectiveDirective
  ],
  //[CommonModule,FormsModule,NgbModule,ReactiveFormsModule, NgSelectModule, NgbDatepickerModule],
  templateUrl: './consignments-popupmodal.component.html',
  styleUrl: './consignments-popupmodal.component.scss',
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
})
export class ConsignmentsPopupmodalComponent implements OnInit {
  nextMonth: string;
  preMonth: string;
  selectMonth: string;
  consignForm: UntypedFormGroup;
  selectYear: string;
  dropdownSettings = {};
  enableLoader: boolean = false;
  @Input() item: any;
  @Input() EditOrders: any;
  @Input() popUp: any;
  @Input() orders: any;
  @Input() buyerRemarks: string;
  @Input() orderCode: string;
  @Input() bidChannel:string;
  allowedDecimalQty:any;
  quoteValidity: any;
  startDate: NgbDate | null = null;
  subconvertedDate: NgbDate | null = null;
  subconvertedDeliveryDate: NgbDate | null = null;
  selectedTime: any;
  usergroup: any;
  master: any;
  errorMessage: any;
  timezone: any;
  selectedMaterials: any = [];
  savedForm: any;
  materialName: any;
  sequenceNumber: any;
  shipToId: any;
  location: any;
  materialId: any;
  quantity: any;
  stockAvailable: any;
  today: NgbDateStruct;
  basePrice: any;
  timeArray = [];
  timeStart = 0; // start time in hours;
  timeEnd = 24; // end time in hours;
  timeInterval = 10; // interval in min;
  validityTime: any;
  validityTimeInput: any;
  deliveryDate: any;
 isPastDeliveryDate:any;
  constructor(
    private cd: ChangeDetectorRef,
    public modalService: NgbModal,
    private toastrService: ToastrService,
    private fb: FormBuilder,
    public ActiveModal: NgbActiveModal,
    private formbuilder: UntypedFormBuilder,
    private customProfileService: CustomProfileService,
    private router: Router
  ) {
    const now = new Date();
    this.today = {
      year: now.getFullYear(),
      month: now.getMonth() + 1,
      day: now.getDate(),
    };
  }
  ngOnInit(): void {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'entryNumber',
      textField: 'displayName',
      itemsShowLimit: 3,
      allowSearchFilter: true,
      defaultOpen: false,
      searchPlaceholderText: 'Search by product name',
    };
    for (let i = this.timeStart; i <= this.timeEnd; i++) {
      const timeString = ('0' + i).slice(-2);
      const timeStringWith0 = timeString + ':00';
      const halfTimeString = timeString + ':30';
      if (halfTimeString !== '24:30') {
        this.timeArray.push(timeStringWith0);
        this.timeArray.push(halfTimeString);
      }
    }
    const savedForm = this.customProfileService.getCurrentBidForm();
    if (savedForm) {
      this.consignForm = savedForm;
      this.getMasterData();
    } else {
      if (this.popUp === 'Edit Order') {
        this.getEditOrderDetails();
      } else if (this.popUp === 'Place Order') {
        this.getConsignmentsPlaceOrder();
      }
    }
  }
  toggle(data: any) {
    data.toggle();
    let element3 = document.getElementsByClassName(
      'btn btn-link ngb-dp-arrow-btn'
    );
    for (let i = 0; i < element3.length; i++) {
      let value = element3[i].getAttribute('title');
      element3[i].setAttribute('title', this.setTitle(value));
    }

    let element4 = document.getElementsByTagName(
      'ngb-datepicker-navigation-select'
    )[0].children;
    for (let i = 0; i < element4.length; i++) {
      let value = element4[i].getAttribute('title');
      element4[i].setAttribute('title', this.setTitle(value));
    }
  }
  setTitle(value) {
    switch (value) {
      case 'Select year':
        return this.selectYear;
      case 'Select month':
        return this.selectMonth;
      case 'Next month':
        return this.nextMonth;
      case 'Previous month':
        return this.preMonth;
      default:
        return;
    }
  }
  next() {
    // let selectedTime = this.master.timeZones.find(x=>{return x.description==this.consignForm.get('Timezone')?.value});
    // console.log('selectedTime',selectedTime);
    if (this.consignForm.invalid) {
      this.consignForm.markAllAsTouched();
    }
    this.customProfileService.setBidForm(this.consignForm);
    const ModalRef = this.modalService.open(
      ConsignmentsConfirmBidPopupComponent,
      { centered: true, size: 'md', backdrop: 'static', keyboard: false }
    );
    ModalRef.componentInstance.consignForm = this.consignForm;
    ModalRef.componentInstance.shipTo = this.shipToId;
    // ModalRef.componentInstance.timezone = selectedTime;
    ModalRef.componentInstance.buyerRemarks = this.EditOrders?.buyerRemarks?this.EditOrders?.buyerRemarks:this.buyerRemarks;
    ModalRef.componentInstance.popup = this.popUp;
    ModalRef.componentInstance.orderCode = this.EditOrders?.quoteCode?this.EditOrders?.quoteCode:this.orderCode;
   ModalRef.componentInstance.bidChannel = this.EditOrders?.bidChannel?this.EditOrders?.bidChannel:this.bidChannel;
    setTimeout(() => this.ActiveModal.close(), 50);
    ModalRef.result.then((result) => {
      if (result) {
        if (result === 'sucess') {
          if (this.popUp === 'Place Order') {
            this.router.navigate([`/quotes`]);
          } else if (this.popUp === 'Edit Order') {
            const currentUrl = this.router.url;
            this.router
              .navigateByUrl('/', { skipLocationChange: true })
              .then(() => {
                this.router.navigate([currentUrl]);
              });
          }
        }
      }
    });
  }
  closeModal() {
    this.ActiveModal.close();
    this.customProfileService.clearBidForm();
  }
  onDateSelection(selectedDate, controlname: 'ValidityDate' | 'deliveryDate') {
    if (selectedDate != null) {
      this.startDate = selectedDate;
      this.consignForm.patchValue({
        [controlname]: this.startDate,
      });
    }
      this.checkPastDeliveryDate(selectedDate);

  }
  checkPastDeliveryDate(selectedDate){
  if(!selectedDate||!selectedDate.year){
    this.isPastDeliveryDate=false;
    return;
  }
  const selectedOrderDate=new Date(selectedDate.year, selectedDate.month - 1, selectedDate.day);
  selectedOrderDate.setHours(0,0,0,0);
  const today=new Date();
  today.setHours(0,0,0,0);
  this.isPastDeliveryDate=selectedOrderDate<today;
}
  checkPad(d) {
    return d < 10 && d.length < 2 ? '0' + d.toString() : d?.toString();
  }
  changeTimeZone(event) {
    this.timezone = event.target.value;
    this.consignForm.patchValue({
      Timezone: this.timezone,
    });
  }
  onTimeSelection(event, controlName) {
    this.selectedTime = event.target.value;
    if (this.selectedTime) {
      this.consignForm.patchValue({
        [controlName]: this.selectedTime,
      });
    }
  }

  getConsignmentsPlaceOrder() {
    this.sequenceNumber = this.item.get('sequenceNumber')?.value;
    this.allowedDecimalQty=this.item.get('allowedDecimalQty')?.value;
    this.shipToId = this.item.get('shipToId')?.value;
    this.location = this.item.get('location')?.value;
    this.materialId = this.item.get('materialId')?.value;
    this.quantity = this.item.get('quantity')?.value;
    this.stockAvailable = this.item.get('stockAvailable')?.value;
    this.basePrice = this.item.get('basePrice')?.getRawValue();
    this.customProfileService
      .getPlaceOrderDetails(this.materialId, this.sequenceNumber, this.shipToId)
      .subscribe(
        (data) => {
          this.enableLoader = false;
          this.selectedMaterials = data;
          if (this.selectedMaterials.priceList?.length > 0) {
            let index = this.selectedMaterials.priceList.findIndex(x=>x.kopCode == 'BASE')
            if (index != -1) {
              this.selectedMaterials.priceList.splice(index, 1);
            }
            this.selectedMaterials.priceList =
              this.selectedMaterials.priceList.sort((a, b) => {
                const nameA = a.kopName.toUpperCase(); // Convert to uppercase for case-insensitive sort
                const nameB = b.kopName.toUpperCase(); // Convert to uppercase for case-insensitive sort

                if (nameA < nameB) {
                  return -1; // nameA comes before nameB
                }
              });
          }
         

          (this.consignForm = this.fb.group({
            //since its only for one material removing form array
            productName: [this?.selectedMaterials?.productName || ''],
            productCode: [this?.selectedMaterials?.productId || ''],
            location: [this?.location || ''],
            shipTo: [this?.shipToId || ''],
            quantity: [this?.quantity || '', Validators.required],
            stockAvailable: [this.stockAvailable || ''],
            deliveryDate: ['', Validators.required],
            extRefNo:[''],
            allowedDecimalQty:[this.allowedDecimalQty],
            // ValidityDate: ['', Validators.required],
            basePrice: [
              {
                value: this.basePrice || '',
                disabled: this.selectedMaterials.restrictedBaseValue === true,
              },
            ],
            restrictedBaseValue: [
              this.selectedMaterials.restrictedBaseValue || false,
            ],
            // ValidityTime: ['', Validators.required],
            // Timezone: [''],
            sequenceNumber: [this.selectedMaterials.sequenceNumber || ''],
            priceList: this.fb.array(
              (this.selectedMaterials.priceList || []).map((price) =>
                this.fb.group({
                  isKopRestricted: [price.isKopRestricted || ''],
                  kopCode: [price.kopCode || ''],
                  kopName: [price.kopName || ''],
                  kopPriceAmount: [
                    {
                      value:
                        price.kopPricePercentage != ''
                          ? price.kopPricePercentage
                          : price.kopPriceAmount || '',
                      disabled: price.isKopRestricted === true,
                    },
                  ],
                  kopPricePercentage: [price.kopPricePercentage || ''],
                  kopPriceSymbol: [price.kopPricePercentage != '' ? '%' : '$'],
                })
              )
            ),
          })),
            this.customProfileService.setBidForm(this.consignForm);
        },
        (err) => {
          this.toastrService.show('Consignments having some error');
          this.enableLoader = false;
        }
      );
    this.getMasterData();

    // Bind to KOPSForm
  }
  getEditOrderDetails() {
    this.selectedMaterials = this.EditOrders.quoteEntries[0];
    let index = this.selectedMaterials.priceList.findIndex(x=>x.kopCode == 'BASE')
            if (index != -1) {
              this.selectedMaterials.priceList.splice(index, 1);
            }
    this.selectedMaterials.priceList = this.selectedMaterials.priceList.sort(
      (a, b) => {
        const nameA = a.kopName.toUpperCase(); // Convert to uppercase for case-insensitive sort
        const nameB = b.kopName.toUpperCase(); // Convert to uppercase for case-insensitive sort

        if (nameA < nameB) {
          return -1; // nameA comes before nameB
        }
      }
    );
    this.quoteValidity = this.EditOrders.quoteValidity;
    if (this.quoteValidity) {
      this.subconvertedDate = this.convert(this.quoteValidity);
    }
    if (this.selectedMaterials.deliveryStartDate) {
      this.subconvertedDeliveryDate = this.convert(
        this.selectedMaterials.deliveryStartDate
      );
     this.checkPastDeliveryDate(this.subconvertedDeliveryDate);

    }
    const vld = new Date(this.EditOrders.quoteValidity);
    const hours = vld.getHours().toString().padStart(2, '0');
    const minutes = vld.getMinutes().toString().padStart(2, '0');
    this.validityTime = hours + ':' + minutes;
    (this.consignForm = this.fb.group({
      //since its only for one material removing form array
      productName: [this?.selectedMaterials?.productName || ''],
      productCode: [this?.selectedMaterials?.productCode || ''],
      location: [this?.selectedMaterials.locationName || ''],
      quantity: [this?.selectedMaterials.quantity || '', Validators.required],
      shipTo: [this?.EditOrders.accountId || ''],
      extRefNo:[this?.EditOrders.externalRefNo || ''],
      allowedDecimalQty:[this.EditOrders.allowedDecimalQty],
      deliveryDate: [this.subconvertedDeliveryDate, Validators.required],
      // ValidityDate: [this.subconvertedDate, Validators.required],
      basePrice: [
        {
          value: this.selectedMaterials.basePriceValue || '',
          disabled:
            this.selectedMaterials.restrictedBaseValue === true ? true : false,
        },
      ],
      restrictedBaseValue: [
        this.selectedMaterials.restrictedBaseValue || false,
      ],
      // ValidityTime: [this.validityTime, Validators.required],
      // Timezone: [''],
      sequenceNumber: [this.selectedMaterials.sequenceNumber || ''],
      stockAvailable: [this?.selectedMaterials.totalStockAvailable || ''],
      priceList: this.fb.array(
        (this.selectedMaterials.priceList || []).map((price) =>
          this.fb.group({
            isKopRestricted: [price.isKopRestricted || ''],
            kopCode: [price.kopCode || ''],
            kopName: [price.kopName || ''],
            kopPriceAmount: [
              {
                value:
                  price.kopPricePercentage != ''
                    ? price.kopPricePercentage
                    : price.kopPriceAmount || '',
                disabled: price.isKopRestricted === true,
              },
            ],
            kopPricePercentage: [price.kopPricePercentage || ''],
            kopPriceSymbol: [price.kopPricePercentage != '' ? '%' : '$'],
          })
        )
      ),
    })),
      this.customProfileService.setBidForm(this.consignForm);

    // this.getMasterData();
  }
  get priceList(): FormArray {
    return this.consignForm.get('priceList') as FormArray;
  }
  getMasterData(): void {
    this.enableLoader = true;
    this.customProfileService.getMasterData(this.usergroup).subscribe(
      (res: MasterData) => {
        this.enableLoader = false;
        if (res) {
          this.master = res;
          // this.checkTimeZone('CST');
          this.cd.detectChanges();
        }
      },
      (err: any) => {
        this.enableLoader = false;
        this.errorMessage = err;
        this.toastrService.show(
          'Sorry something went wrong, please try again!'
        );
      }
    );
  }
  convert(dateString: string): NgbDate {
    const date = new Date(dateString);
    return new NgbDate(date.getFullYear(), date.getMonth() + 1, date.getDate());
  }
  formatDate(date: any) {
    if (date && date.year && date.month && date.day)
      return (
        date.day +
        '/' +
        this.checkPad(date.month) +
        '/' +
        this.checkPad(date.year)
      );
  }
  checkTimeZone(value) {
    const currentTimezone = this.consignForm.get('Timezone')?.value;
    if (!currentTimezone) {
      this.master?.timeZones.filter((val) => {
        if (value == val.code) {
          this.consignForm.patchValue({
            Timezone: val.description,
          });
        }
      });
    }
  }
  restrictInput(event: KeyboardEvent): void {
    const allowedKeys = [
      'Backspace',
      'ArrowLeft',
      'ArrowRight',
      'Delete',
      'Tab',
      'Control',
      'Meta',
      'a',
      'c',
      'v',
      'x',
    ];
    const ctrlCmd = event.ctrlKey || event.metaKey;
    if (ctrlCmd && ['a', 'c', 'v', 'x'].includes(event.key.toLowerCase())) {
      return;
    }
    const isNumber = /^[0-9]$/.test(event.key);
    const isLetter = /^[a-zA-Z]$/.test(event.key);
    const isAllowed = allowedKeys.includes(event.key);
    if (!isNumber && !isLetter && !isAllowed) {
      event.preventDefault();
    }
  }
  changeValidityTime(event) {
    let validityTime = event.target.value;
    this.validityTimeInput = validityTime;
    if (this.validityTimeInput == null || this.validityTimeInput == '') {
      this.validityTime = null;
    }
  }
}
